/** Balık tutma ve Çalışma menüsü için minimum karakter seviyesi */
export const FISHING_MIN_LEVEL = 20;
